import React from 'react';
import { motion } from 'framer-motion';
export function TropicalBackground() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-id="element-23">
      {/* Sunset sky gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#FFB36B] via-[#FF7E9D] to-[#2EC4B6]" data-id="element-24" />

      {/* Soft sun glow */}
      <motion.div initial={{
      opacity: 0.6,
      scale: 0.95
    }} animate={{
      opacity: [0.6, 0.85, 0.6],
      scale: [0.95, 1, 0.95]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-[12%] left-1/2 -translate-x-1/2 w-72 h-72 rounded-full bg-[#FFE08A] blur-3xl" data-id="element-25" />
      <div className="absolute top-[16%] left-1/2 -translate-x-1/2 w-40 h-40 rounded-full bg-[#FFD56B]" data-id="element-26" />

      {/* Ocean shimmer band near bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-b from-transparent to-[#159A91]/60" data-id="element-27" />

      {/* Palm silhouettes */}
      <svg className="absolute bottom-0 left-[-20px] w-48 md:w-64 text-[#103D3A]/85" viewBox="0 0 200 320" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-28">
        <path d="M98 320 C92 220 96 150 100 120" stroke="currentColor" strokeWidth="8" strokeLinecap="round" data-id="element-29" />
        <path d="M100 120 C70 95 35 92 8 105 C40 100 72 110 100 122" fill="currentColor" data-id="element-30" />
        <path d="M100 120 C130 95 165 92 192 105 C160 100 128 110 100 122" fill="currentColor" data-id="element-31" />
        <path d="M100 118 C85 80 55 55 25 48 C58 62 84 92 100 120" fill="currentColor" data-id="element-32" />
        <path d="M100 118 C115 80 145 55 175 48 C142 62 116 92 100 120" fill="currentColor" data-id="element-33" />
        <path d="M100 116 C98 78 100 45 104 20 C100 50 100 86 100 118" fill="currentColor" data-id="element-34" />
      </svg>

      <svg className="absolute bottom-0 right-[-30px] w-56 md:w-72 text-[#0C302E]/80 scale-x-[-1]" viewBox="0 0 200 360" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-35">
        <path d="M98 360 C92 240 96 160 100 130" stroke="currentColor" strokeWidth="9" strokeLinecap="round" data-id="element-36" />
        <path d="M100 130 C68 102 30 99 0 113 C36 107 72 119 100 132" fill="currentColor" data-id="element-37" />
        <path d="M100 130 C132 102 170 99 200 113 C164 107 128 119 100 132" fill="currentColor" data-id="element-38" />
        <path d="M100 128 C84 86 52 58 20 50 C56 66 84 98 100 130" fill="currentColor" data-id="element-39" />
        <path d="M100 128 C116 86 148 58 180 50 C144 66 116 98 100 130" fill="currentColor" data-id="element-40" />
        <path d="M100 126 C98 84 100 48 105 22 C100 54 100 92 100 128" fill="currentColor" data-id="element-41" />
      </svg>

      {/* Subtle grain for depth */}
      <div className="absolute inset-0 bg-noise opacity-50" data-id="element-42" />

      {/* Darkening scrim so the card and any edge text stay legible */}
      <div className="absolute inset-0 bg-black/5" data-id="element-43" />
    </div>;
}